export default "__VITE_ASSET__BbyfWM4n__$_?url__"